import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { useContext } from "react";

import logger from "../logger";
import {
  REACT_APP_ENABLE_APP_INSIGHTS,
  REACT_APP_ENV,
  SERVICE_NAME,
} from "../../configs";
import { UserInfo } from "../../context";

const useTrackEvent = () => {
  const appInsights = useAppInsightsContext();
  const { username } = useContext(UserInfo);

  function trackEvent(name: string, options: any = {}): void {
    if (REACT_APP_ENABLE_APP_INSIGHTS) {
      appInsights.trackEvent(
        { name },
        {
          inputData: options,
          name: username,
          service: SERVICE_NAME,
          env: REACT_APP_ENV,
        }
      );
      logger.info(`[appInsightsTracking] ${name}`);
    }
  }

  return trackEvent;
};

export default useTrackEvent;
